var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "q-row",
    [
      _c(
        "q-col",
        { attrs: { span: 5 } },
        [
          _c(
            "q-collapse",
            { attrs: { accordion: "" } },
            _vm._l(_vm.groups, function (group) {
              return _c(
                "q-collapse-item",
                { key: group.key, attrs: { name: group.caption } },
                [
                  _c("template", { slot: "title" }, [
                    _c("span", [_vm._v(_vm._s(group.caption))]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "q-drag",
                    {
                      attrs: {
                        element: "ul",
                        list: group.components,
                        options: _vm.componentsOptions,
                        clone: _vm.onClone,
                      },
                    },
                    _vm._l(group.components, function (component) {
                      return _c(
                        "li",
                        {
                          key: component.key,
                          staticClass: "q-draggable__item",
                          staticStyle: { border: "1px solid #8e8e8e" },
                        },
                        [_c("span", [_vm._v(_vm._s(component.label))])]
                      )
                    }),
                    0
                  ),
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-col",
        { attrs: { span: 14 } },
        [
          _vm.elements.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "q-button",
                    {
                      attrs: { type: "danger", disabled: _vm.disabled },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.clearItems()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(this.$qt("el.draggable.emptyText")) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "q-drag",
            {
              class: [
                "list-group dropArea",
                !_vm.elements.length ? "empty" : "",
              ],
              attrs: {
                element: "ul",
                list: _vm.elements,
                options: _vm.formOptions,
                move: _vm.onMove,
                "data-content": this.$qt("el.draggable.dataContent"),
              },
              on: {
                start: function ($event) {
                  _vm.isDragging = true
                },
                end: function ($event) {
                  _vm.isDragging = false
                },
              },
            },
            _vm._l(_vm.elements, function (element, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "list-group-item q-draggable__item",
                  style:
                    index % 2 === 0
                      ? "background-color: #EBEBEB"
                      : "background-color: #D7D7D7",
                },
                [
                  _c("q-element-generator", {
                    attrs: { element: element },
                    model: {
                      value: _vm.model,
                      callback: function ($$v) {
                        _vm.model = $$v
                      },
                      expression: "model",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "q-button-group",
                    [
                      _c(
                        "q-button",
                        {
                          attrs: { disabled: _vm.disabled, type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.removeElement(index)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "trash"] },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "q-button",
                        {
                          attrs: { disabled: _vm.disabled, type: "text" },
                          on: {
                            click: function ($event) {
                              return _vm.elementDetail(index)
                            },
                          },
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: ["fas", "cog"] },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-col",
        { attrs: { span: 5 } },
        [_c("q-json", [_vm._v(_vm._s(_vm.elements))])],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: "جزئیات",
            width: "50%",
            "append-to-body": "",
            visible: _vm.elementSettingDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.elementSettingDialog = $event
            },
          },
        },
        [
          _c("q-element-setting", {
            attrs: { model: {} },
            model: {
              value: _vm.currentElement,
              callback: function ($$v) {
                _vm.currentElement = $$v
              },
              expression: "currentElement",
            },
          }),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.elementSettingDialog = false
                    },
                  },
                },
                [_vm._v("تایید")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }